import { CLEAR, ERROR, LOADING, SUCCESS } from '../../Constants/commonConstants';
import {
  CLEAR_FAILED_DOCUMENTS,
  CLEAR_MESSAGE,
  FEEDBACK_SENT,
  GET_SAVED_DOCCHAT_HISTORY,
  SELECTED_DOCUMENT_INFO,
  SET_MESSAGE,
  UPLOAD_DOCUMENT,
} from './docChatTypes';

export const initialState = {
  uploadFile: {
    message: '',
    documentId: '',
    document_link: '',
    document_name: '',
    collection_id: '',
    collection_name: '',
    documents: '',
    presetId: null,
  },
  uploadStatus: '',
  selectedDocument: {
    documentId: '',
    document_link: '',
    document_name: '',
    chat_history: '',
    chat_id: '',
    chat_start_time: '',
  },
  records: [],
  remainingQuota: null,
  savedDocChatRecordStatus: '',
  renameStatus: '',
  failedDocuments: [],
};

export const docChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_DOCUMENT:
      if (action.uploadStatus === SUCCESS) {
        return {
          ...state,
          uploadFile: action.uploadFile,
          uploadStatus: action.uploadStatus,
          failedDocuments: action.failedDocuments || [],
        };
      }
      if (action.uploadStatus === LOADING) {
        return {
          ...state,
          uploadFile: initialState.uploadFile,
          uploadStatus: action.uploadStatus,
        };
      }
      if (action.uploadStatus === ERROR) {
        return {
          ...state,
          uploadFile: action.uploadFile,
          uploadStatus: action.uploadStatus,
        };
      }
      if (action.uploadStatus === CLEAR) {
        return {
          ...state,
          uploadFile: initialState.uploadFile,
          uploadStatus: action.uploadStatus,
        };
      }
      break;
    case CLEAR_FAILED_DOCUMENTS:
      return {
        ...state,
        failedDocuments: [],
      };
    case GET_SAVED_DOCCHAT_HISTORY:
      return {
        ...state,
        records: action.records?.sort(
          (a, b) =>
            new Date(b.created_time || b.chat_start_time) -
            new Date(a.created_time || a.chat_start_time)
        ),
        savedDocChatRecordStatus: action.savedDocChatRecordStatus,
        remainingQuota: action?.remainingQuota,
      };
    case SELECTED_DOCUMENT_INFO:
      return { ...state, selectedDocument: action.selectedDocument };
    case SET_MESSAGE:
      return {
        ...state,
        records: state.records?.map((el) => {
          if (
            (el?.collection_id && el?.collection_id === action?.collection_id) ||
            (el?.document_id && el?.document_id === action?.documentId)
          ) {
            return {
              ...el,
              chat_history: [
                ...(el?.chat_history || []),
                {
                  timestamp: action.timestamp,
                  role: action.role,
                  content: action.content,
                  query_response_id: action.query_response_id,
                  download_url: action.download_url,
                  content_length: action.content_length,
                },
              ],
            };
          }
          return el;
        }),
      };
    case CLEAR_MESSAGE:
      console.info('clear chat', action);

      return {
        ...state,
        records: state.records?.map((el) => {
          if (
            (el?.collection_id && el?.collection_id === action?.collection_id) ||
            (el?.document_id && el?.document_id === action?.documentId)
          ) {
            return {
              ...el,
              chat_id: action.chat_id,
              chat_history: [],
            };
          }
          return el;
        }),
      };
    case FEEDBACK_SENT:
      return {
        ...state,
        records: state.records?.map((el) => {
          if (el?.collection_id === action.collection_id || el?.document_id === action.documentId) {
            return {
              ...el,
              chat_history: el?.chat_history?.map((itm) => {
                if (itm?.query_response_id === action?.query_response_id) {
                  return { ...itm, feedback: action.feedback };
                }
                return itm;
              }),
            };
          }
          return el;
        }),
      };
    default:
      return state;
  }
};
